import { DirectoryTreeview, ITreeviewData } from "@starrez/starryui";
import * as React from "react";

export interface ITemplateTreeViewProps {
    Data: ITreeviewData[];
    OnFolderClick: (item: ITreeviewData) => void;
    Selected: string;
}

export const TemplateTreeView = React.memo(({ Data, OnFolderClick, Selected }: ITemplateTreeViewProps) => {
    const [selectedTreeviewItem] = React.useState(Selected);

    return (
        <DirectoryTreeview Data={Data} OnFolderClick={OnFolderClick} Selected={selectedTreeviewItem}/>
    );
}, (prevProps, nextProps) => prevProps.Data === nextProps.Data);
